import React from 'react';
import PropTypes from 'prop-types';
import './Paragraph.scss';

const Paragraph = ({
  additionalClass,
  color,
  children,
  serif,
  spaced,
  size,
  nested,
}) => {
  const serifClass = serif ? 'paragraph--serif' : '';
  const colorClass = color ? `text--${color}` : '';
  const spaceClass = spaced ? 'paragraph--spaced' : '';
  const classes = `paragraph paragraph--${size} ${colorClass} ${spaceClass} ${serifClass} ${additionalClass}`;

  return nested ? (
    <div className={classes}>{children}</div>
  ) : (
    <p className={classes}>{children}</p>
  );
};

Paragraph.defaultProps = {
  additionalClass: '',
  size: 'regular',
  color: 'default',
  serif: false,
  spaced: false,
  nested: false,
};

Paragraph.propTypes = {
  additionalClass: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  serif: PropTypes.bool,
  spaced: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  nested: PropTypes.bool,
};

export default Paragraph;
